import Default from './Default';
import Dissertation from './Dissertation';
import Manuscript from './Manuscript';
import Book from './Book';
import Serial from './Serial';

export const Templates = [Default, Book, Dissertation, Manuscript, Serial];

export const DefaultTemplate = () => Templates.find((template) => template.isDefault === true);
